import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ProcurementPurchaseOrdersPurchaseRequestSummaryFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import CardLinked from 'modules/procurement/components/CardLinked'
import InfoItem from 'modules/procurement/components/InfoItem'

interface Props {
  purchaseRequest: ProcurementPurchaseOrdersPurchaseRequestSummaryFragment
}

const PurchaseRequestInfo = ({ purchaseRequest }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Box gap="s12">
      <Text weight="bold" size="200" color="grey800" caps>
        {i18n.t('procurement.purchase_orders.detail.purchase_request.title')}
      </Text>
      <CardLinked
        item={
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.purchase_request.requested_by')}
            item={
              <Box flexDirection="row" alignItems="center" gap="s8" paddingTop="s2">
                <Avatar
                  size="s40"
                  url={buildUrl(purchaseRequest.requesterEmployee?.avatar?.url)}
                  label={purchaseRequest.requesterEmployee?.fullName || ''}
                />
                <Text.Normal size="200" weight="medium">
                  {purchaseRequest.requesterEmployee?.fullName || ''}
                </Text.Normal>
              </Box>
            }
          />
        }
        to={navigation.procurement.purchaseRequests.detail.fullPath({ id: purchaseRequest.id })}
      />
    </Box>
  )
}

export default PurchaseRequestInfo
